import type { USStates } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/location/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { apiIns } from 'src/config/apiClient';

export const getUSState = createAsyncThunk<USStates[], void>('usState/getUSState', async (_, { rejectWithValue }) => {
  try {
    const response: USStates[] = await apiIns.location.USStates();
    return response;
  } catch (error: any) {
    message.error(error.message);
    return rejectWithValue(error.message);
  }
});
